export default function () {
    jQuery(document).ready(function (e) {
        const uploadButtons = $('.uploadfield-button');
        const uploadFields = $('input.file');

        // when buttons are clicked, trigger upload
        uploadButtons.each(function () {
            var id = $(this)[0].id;
            id = id.replace('-button', '');

            $(this)[0].addEventListener("click", function () {
                $('#' + id).click();
            })

            $(this)[0].addEventListener("keyup", function () {
                if (event.keyCode === 13) {
                    $('#' + id).click();
                }
            })
        });

        // when upload has completed, update textfield with filename
        uploadFields.each(function () {
            $(this)[0].addEventListener("change", function () {
                var id = $(this)[0].id;
                var button = $('#' + id + '-button');
                var text = $('#' + id + '-text');

                if ($(this)[0].value) {
                    let filePath = $(this)[0].value;
                    let fileArray = filePath.split("\\");
                    button.innerHTML = "File uploaded";

                    text[0].setAttribute('placeholder', fileArray.pop());
                } else {
                    text[0].innerHTML = "No file uploaded";
                }
            })
        });

        // error messages on submission
        let submitButton = $('input.action');

        submitButton.on('click', function () {
            $('.message-area').attr('style', 'display: none; visibility: hidden;');

            setTimeout(function () {
                let errorMessages = $('div.field').find('span.error.message');

                errorMessages.each(function () {
                    $(this).hide();
                    var text = $(this)[0].innerText;
                    var id = $(this)[0].id;

                    var customMessage = $(this).siblings('.message-area');
                    customMessage
                      .find('.error-text')
                      .text(text);

                    customMessage
                      .removeAttr('style');

                    $(this).remove();
                });
            }, 100);

            setTimeout(function () {
                const errorList = $('ul.error-list').find('a');
                const allErrors = ['There has been errors with your submission. Please correct the following errors:'];

                errorList.each(function () {
                    let fieldID = $(this).parent().attr('ID');
                    fieldID = fieldID.replace('-top-error', '');

                    allErrors.push($(this).text());

                    let linkURL = $(this).attr('href');
                    linkURL = linkURL.replace('#undefined', '#' + fieldID);
                    $(this).attr('href', linkURL);//.append('<span class="visually-hidden">Click to go to where you can fix this error.</span>');
                });

                // $('input, select, textarea', 'form.userform').each(function () {
                //   $(this).attr('aria-describedby', `${this.id}-error-message`);
                // });

              const alertSection = $('#alert-section');
              alertSection.children().remove();
              alertSection.append(`<p role="alert">${allErrors.toString()}</p>`);

                const container = $('.error-container').first();
                container.find('h4').first().replaceWith(() => '<h3>There has been errors with your submission.</h3><p>Please correct the following errors.</p>').attr('tabindex', 0)
                  .focus();

              $('ul.error-list').first().attr('tabindex', '-1').focus();
            }, 250);
        });
    });
};



// WEBPACK FOOTER //
// ./themes/app/src/js/validation.js